import React, { useEffect, useState } from 'react';
import style from '../styles/deviceResult.module.css';
import earthIcon from '../../../assets/images/earthIcon.webp';
import networkIcon from '../../../assets/images/networkIcon.webp';
import markIcon from '../../../assets/images/markIconSmall.webp';
import { CheckIcon } from '@heroicons/react/24/solid';
import StartTrackingButton from '../../../components/sharedComponents/StartTrackingButton';
import { useNavigate } from "react-router-dom";
import verificationVideo from '../../../assets/suvreyImages/animations/mobilevcerificationAnimation.mp4';

const DeviceVerificationResults = ({ data }) => {
    const [dataReady, setDataReady] = useState(false);
    const [trackingPossible, setTrackingPossible] = useState(false);
    const [carrierDataCountry, setCarrierDataCountry] = useState('');
    const [carrierDataCarrier, setCarrierDataCarrier] = useState('');
    const [carrierDataConfirmed, setCarrierDataConfirmed] = useState('');

    const navigate = useNavigate();

    useEffect(() => {
        if (data) {
            setTimeout(() => { setDataReady(true) }, 1000);
            setTimeout(() => { setCarrierDataCountry(data.country) }, 2500);
            setTimeout(() => { setCarrierDataCarrier(data.carrier) }, 4000);
            setTimeout(() => { setCarrierDataConfirmed("Yes") }, 5000);
            setTimeout(() => { setTrackingPossible(true) }, 6500);
        }

    }, [data]);

    const startSurvey = () => {
        navigate('/survey', {
            state: {
                data: null
            }
        });
    }

    return (
        <div className={style.popup}>
            <div className={style.headerContainer}>
                <h1 className={style.header}>Checking device</h1>
            </div>
            <div className={style.mainContainer}>
                <div className={style.verificationContainer}>
                    {carrierDataCountry && <div className={style.verificationResult}>
                        <div className={style.resultBlock}><img src={earthIcon} alt="earth_Icon" /><p >Location:</p></div><span className={style.result}>{carrierDataCountry}</span>
                    </div>}
                    {carrierDataCarrier &&
                        <div className={style.verificationResult}>
                            <div className={style.resultBlock}>
                                <img src={networkIcon} alt="Network_Icon" />
                                <p >Network:</p>
                            </div>
                            <span className={style.result}>
                                {carrierDataCarrier}
                            </span>
                        </div>}
                    {carrierDataConfirmed && <div className={style.verificationResult}>
                        <div className={style.resultBlock}><img src={markIcon} alt="mark_Icon" /><p style={{ color: '#F15223' }}>Tracking available:</p></div><span className={style.resultNetwork}>{carrierDataConfirmed}</span>
                    </div>}
                </div>
                {!trackingPossible ?
                    <div className={style.videoContainer}>
                        <video className={style.video} autoPlay loop muted>
                            <source src={verificationVideo} type="video/mp4" />
                        </video>
                    </div> :
                    <div className={style.featureContainer}>

                        <ul className={style.featureList}>
                            <li >
                                <CheckIcon className={style.featureIcon} /><p className={style.feature}>Track <span className="hightLightText">5</span> devices at once</p>
                            </li>
                            <li>
                                <CheckIcon className={style.featureIcon} /><p className={style.feature}><span className="hightLightText">Unlimited</span> tracking</p>
                            </li>
                            <li >
                                <CheckIcon className={style.featureIcon} /><p className={style.feature}>Up to <span className="hightLightText">30 days</span> location history</p>
                            </li>
                            <li >
                                <CheckIcon className={style.featureIcon} /><p className={style.feature}>Track <span className="hightLightText">Apple & Android</span></p>
                            </li>
                            <li >
                                <CheckIcon className={style.featureIcon} /><p className={style.feature}>Works on <span className="hightLightText">all networks</span></p>
                            </li>
                        </ul>
                        <StartTrackingButton title="Get Started" style={style.startTrackingButton} onButtonClick={startSurvey} />
                    </div>
                }
            </div>
        </div>

    )
}

export default DeviceVerificationResults